import React, { useEffect, useState, } from "react";
import axios from "../../../utills/api";
import { Container, Row, Col, Card, CardBody, } from "reactstrap";
import { useNavigate, useLocation, useParams, } from "react-router-dom";
import FoodOrder from "./FoodOrder";
// import Spa from "./Spa";
import Housekeeping from "./Housekeeping";
import GuestActivity from "./GuestActivity";
import { GiKnifeFork, } from "react-icons/gi";
import { RiHotelLine, RiCustomerService2Line, RiShirtLine, RiSparkling2Line, } from "react-icons/ri";

const GuestPortal = () => {
    const { roomNumber, tenantId } =
        useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const currentPage =
        location.pathname.split("/")[3] || "home";

    const [booking, setBooking] =
        useState(null);

    const [currentTime, setCurrentTime] =
        useState(new Date());

    useEffect(() => {
        loadGuestBooking();

        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const loadGuestBooking = async () => {
        try {

            const { data } =
                await axios.get(
                    "/bookings/guest-room",
                    {
                        params: {
                            tenantId,
                            roomNumber,
                        },
                    }
                );

            setBooking(data);

        } catch (err) {

            console.error(err);

        }
    };

    if (!booking) {
        return (
            <div className="text-center mt-5">
                Loading Guest Details...
            </div>
        );
    }

    return (
        <div className="guestPortal">

            {/* HEADER */}

            <div className="guestHeader">

                <div>

                    <h4 className="mb-0">
                        Hotel Paradise
                    </h4>

                    <small>
                        Mussoorie, Uttarakhand
                    </small>

                </div>

                <div className="text-end">

                    <div>
                        {currentTime.toLocaleDateString()}
                    </div>

                    <div>
                        {currentTime.toLocaleTimeString()}
                    </div>

                </div>

            </div>

            {/* GUEST SUMMARY */}

            <div className="guestSummary">

                <div className="summaryItem">
                    <h6>Guest</h6>

                    <div>
                        {booking.name}
                    </div>

                    <small>
                        {booking.mobile}
                    </small>
                </div>

                <div className="summaryItem">
                    <h6>Room</h6>

                    <div>
                        {booking.assignedRoom?.roomNumber}
                    </div>

                    <small>
                        {booking.roomType}
                    </small>
                </div>

                <div className="summaryItem">
                    <h6>Check-In</h6>

                    <div>
                        {new Date(
                            booking.actualCheckIn
                        ).toLocaleDateString()}
                    </div>

                    <small>
                        {new Date(
                            booking.actualCheckIn
                        ).toLocaleTimeString()}
                    </small>
                </div>

                <div className="summaryItem">
                    <h6>Check-Out</h6>

                    <div>
                        {new Date(
                            booking.checkOut
                        ).toLocaleDateString()}
                    </div>

                    <small>
                        {
                            booking.scheduledCheckOutTime
                        }
                    </small>
                </div>

            </div>

            <Container fluid>

                {/* SERVICE CARDS */}

                <Row className="g-3 mt-2">

                    <Col xs={6}>
                        <Card
                            className="serviceCard"
                            onClick={() =>
                                navigate(
                                    `/guest-portal/${tenantId}/${roomNumber}/food`
                                )
                            }
                        >
                            <CardBody>

                                <GiKnifeFork
                                    size={40}
                                />

                                <h6>
                                    Food Order
                                </h6>

                            </CardBody>
                        </Card>
                    </Col>

                    <Col xs={6}>
                        <Card
                            className="serviceCard"
                            onClick={() =>
                                navigate(
                                    `/guest-portal/${tenantId}/${roomNumber}/spa`
                                )
                            }
                        >
                            <CardBody>

                                <RiSparkling2Line
                                    size={40}
                                />

                                <h6>Spa</h6>

                            </CardBody>
                        </Card>
                    </Col>

                    <Col xs={6}>
                        <Card
                            className="serviceCard"
                            onClick={() =>
                                navigate(
                                    `/guest-portal/${tenantId}/${roomNumber}/housekeeping`
                                )
                            }
                        >
                            <CardBody>

                                <RiHotelLine
                                    size={40}
                                />

                                <h6>
                                    Housekeeping
                                </h6>

                            </CardBody>
                        </Card>
                    </Col>

                    <Col xs={6}>
                        <Card className="serviceCard"
                            onClick={() =>
                                navigate(
                                    `/guest-portal/${tenantId}/${roomNumber}/laundry`
                                )
                            }>
                            <CardBody>

                                <RiShirtLine
                                    size={40}
                                />

                                <h6>Laundry</h6>

                            </CardBody>
                        </Card>
                    </Col>

                </Row>

                <Row>
                    <Card className="mt-4 border-0 shadow-sm">
                        <CardBody>

                            <GuestActivity
                                booking={booking}
                            />

                        </CardBody>
                    </Card>
                </Row>

                {/* CONTENT */}
                {/* CONTENT */}

                <div className="mt-4">

                    {currentPage === "home" && (
                        <Card className="border-0 shadow-sm">
                            <CardBody className="text-center py-5">
                                <h4>Welcome 👋</h4>
                                <p className="text-muted mb-0">
                                    Please select a service above to continue.
                                </p>
                            </CardBody>
                        </Card>
                    )}

                   {currentPage === "food" && (
    <FoodOrder
        booking={booking}
        roomNumber={roomNumber}
    />
)}

                    {currentPage === "spa" && (
                        <div className="text-center py-5">
                            Spa Page
                        </div>
                        // Replace with:
                        // <Spa booking={booking} />
                    )}

                    {currentPage === "housekeeping" && (
                        <Housekeeping booking={booking} />
                    )}

                    {currentPage === "laundry" && (
                        <div className="text-center py-5">
                            Laundry Page
                        </div>
                        // Replace with:
                        // <Laundry booking={booking} />
                    )}

                </div>

            </Container>

        </div>
    );
};

export default GuestPortal;